/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdGroupPermissionsUpdateRequest
 */
export interface AdGroupPermissionsUpdateRequest {
    /**
     * 
     * @type {Array<any>}
     * @memberof AdGroupPermissionsUpdateRequest
     */
    permissionIds?: Array<any> | null;
}

/**
 * Check if a given object implements the AdGroupPermissionsUpdateRequest interface.
 */
export function instanceOfAdGroupPermissionsUpdateRequest(value: object): value is AdGroupPermissionsUpdateRequest {
    return true;
}

export function AdGroupPermissionsUpdateRequestFromJSON(json: any): AdGroupPermissionsUpdateRequest {
    return AdGroupPermissionsUpdateRequestFromJSONTyped(json, false);
}

export function AdGroupPermissionsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdGroupPermissionsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
    };
}

export function AdGroupPermissionsUpdateRequestToJSON(json: any): AdGroupPermissionsUpdateRequest {
    return AdGroupPermissionsUpdateRequestToJSONTyped(json, false);
}

export function AdGroupPermissionsUpdateRequestToJSONTyped(value?: AdGroupPermissionsUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionIds': value['permissionIds'],
    };
}

